export enum PortCallPdaStatuses {
  CALCULATED = 'calculated',
  MISSING_DATA = 'missing_data',
  APPROVED = 'approved',
}
